<template>
    <div>
        <group-card icon="branding_watermark" title="Co-Branding" padded>
            <md-subheader class="sub-header">
              Details
          </md-subheader>
          <div class="md-layout md-gutter">
            <validated-text-input
              class="md-layout-item"
              label="Book a Callback Time"
              v-model="data.hubspot.call_back_time_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid link to set a time."
              url
            />
            <md-checkbox
                class="md-layout-item"
                v-model="data.hubspot.co_branding_opt_in"
                :checked='data.hubspot.co_branding_opt_in'
                :disabled="!pageEditable"
              >
              Branded Transactional Comms Opt In
            </md-checkbox>
            <validated-autocomplete-input
              class="md-layout-item"
              label="Branding Type"
              v-model="data.hubspot.branding_type"
              :options="hubspot_branding_types"
              :disabled="!pageEditable"
              :required = "pageEditable"
              force
            />
          </div> <br>
          <div class="md-layout md-gutter">
            <search-text-input class="md-layout-item md-size-100"
                label="Broker"
                v-model="data.hubspot.broker.name"
                :searcher="performSearch"
                :disabled="!pageEditable"
                @select="setBroker"
                min-length="2"
                clearable
            >
              <template v-slot="{ item }">
                {{ item.name }}
              </template>
            </search-text-input>
            <validated-text-input
              class="md-layout-item"
              label="Broker Logo"
              v-model="data.hubspot.broker_logo_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
            <validated-text-input
              class="md-layout-item"
              label="Company Default Email"
              v-model="data.hubspot.company_default_email"
              melissaCheckType="email"
              disabled
            />
          </div> <br>
          <div class="md-layout md-gutter">
            <validated-number-input
              class="md-layout-item"
              label="Pod Id"
              v-model="pod_id"
              :disabled="true"
            />
            <validated-autocomplete-input
              class="md-layout-item"
              label="Pod Name"
              v-model="data.hubspot.pod_name"
              :options="allPods.map(i => i.name)"
              :disabled="!pageEditable"
            />
          </div> <br>
          <md-subheader class="sub-header">
            Social Media Links
          </md-subheader>
          <div class="md-layout md-gutter">
            <validated-text-input
              class="md-layout-item"
              label="Facebook Company Page"
              v-model="data.hubspot.facebook_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
            <validated-text-input
              class="md-layout-item"
              label="Google Review Link"
              v-model="data.hubspot.google_review_link"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
            <validated-text-input
              class="md-layout-item"
              label="Instagram Page"
              v-model="data.hubspot.instagram_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
            <validated-text-input
              class="md-layout-item"
              label="Twitter Bio"
              v-model="data.hubspot.twitter_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
            <validated-text-input
              class="md-layout-item"
              label="LinkedIn Page"
              v-model="data.hubspot.linkedin_url"
              :disabled="!pageEditable"
              errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
              url
            />
          </div>
          </group-card>
          <group-card icon="branding_watermark" title="HubDB" padded>
            <md-subheader class="sub-header">
              IDs
          </md-subheader>
            <div class="md-layout md-gutter">
              <validated-number-input
                class="md-layout-item"
                label="Zink2 Referral ID"
                v-model="data.user_id"
                :disabled="true"
              />
              <validated-text-input
                class="md-layout-item"
                label="Affiliate ID"
                v-model="data.hubspot.affiliate_id"
                :disabled="!pageEditable"
              />
              <validated-number-input
                class="md-layout-item"
                label="Zink2 Broker ID"
                v-model="data.hubspot.broker.user_id"
                :disabled="true"
              />
            </div> <br>
            <md-subheader class="sub-header">
              Introducer
            </md-subheader>
            <div class="md-layout md-gutter">
              <validated-text-input
                class="md-layout-item"
                label="QR Code"
                v-model="data.hubspot.qr_code_url"
                :disabled="!pageEditable"
                errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                url
              />
            </div> <br>
            <md-subheader class="sub-header">
              Other
            </md-subheader>
            <div class="md-layout md-gutter">
              <md-checkbox
                v-model="data.hubspot.is_veda_disabled"
                class="md-layout-item"
                :disabled="!pageEditable"
                >
                Veda Disabled
              </md-checkbox>
              <validated-select-input
                class="md-layout-item md-size-85"
                label="Loan Purpose"
                v-model="data.hubspot.loan_purpose"
                :options="hubspot_loan_purposes"
                :disabled="!pageEditable"
                :required = "pageEditable"
                force
              />
            </div>
            <br>
            <md-subheader class="sub-header">
              Image
            </md-subheader>
            <div class="md-layout md-gutter">
              <validated-text-input
                class="md-layout-item"
                label="Referrer Logo"
                v-model="data.hubspot.referrer_logo_url"
                :disabled="!pageEditable"
                errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                url
              />
              <div class="md-layout-item">
                  <ValidationProvider v-slot="{ failed, validate }" ref="validator" immediate rules="mimes:image/jpeg,image/jpeg,image/gif,image/png|size:2048">
                    <md-field :class="{ 'md-error': failed}">
                      <label>
                        Referrer Avatar
                      </label>
                      <input type="file"
                        :disabled="!pageEditable"
                        multiple="false"
                        @change="onFileChange"
                        id="assetsFieldHandle"
                        ref="referrer_avatar"
                        accept=".jpg,.jpeg,.gif,.png"
                      />
                      </md-field>
                      <span v-if="failed" class="error-msg">Only .jpg,.jpeg,.png,.gif files with max 2mb accepted.</span>
                  </ValidationProvider>
                  <img v-if="referrer_avatar_url" :src="referrer_avatar_url" class="referrer-logo" alt="referrer_avatar_url"/>
              </div>
              <validated-text-input
                class="md-layout-item"
                label="Background Image"
                v-model="data.hubspot.background_image_url"
                :disabled="!pageEditable"
              />
            </div>
          </group-card>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import ValidatedAutocompleteInput from "../components/ValidatedInput/ValidatedAutocompleteInput";
import {GroupCard} from "@/components";
export default {
components: {
    GroupCard,
    ValidatedAutocompleteInput,
    ...ValidatedInputs,
  },
  data() {
    return {
      allPods: [],
      avatarFile: null,
    }
  },
  props: {
    data: {
      type: Object,
      default: ''
    },
    pageEditable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async onFileChange(event, index) {
        const { valid, errors } = await this.$refs.validator.validate(event.target.files[0])
        if (valid) {
            this.file = event.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.data.hubspot.referrer_avatar_file = reader.result;
                this.avatarFile = this.data.hubspot.referrer_avatar_file
            };
            reader.readAsDataURL(this.file);
        } else {
            this.$refs.referrer_avatar.value = null;
        }
    },
    async getAllPods() {
      const response = await axios.get('/api/v1/administration/user_pods')
      this.allPods = response.data
    },
    async performSearch(query) {
      let formatted_query = query.trimLeft()
      let brokers = await axios.get(`/api/v1/administration/role_based_users/${formatted_query}/broker`);
      return brokers.data;
    },
    setBroker(selectedBroker){
      this.data.hubspot.broker.name = selectedBroker.name;
      this.data.hubspot.broker.user_id = selectedBroker.id;
    }
  },
  created() {
    this.getAllPods();
  },
  computed: {
    ...mapGetters([
      'options',
    ]),
    hubspot_branding_types() {
        return this.options.hubspot_branding_type;
    },
    referrer_avatar_url() {
        return this.avatarFile ? this.avatarFile :  this.data.hubspot.referrer_avatar_url;
    },
    pod_id: {
      get() {
        const selected_pod = this.allPods.find(pod => {
          return pod.name === this.data.hubspot.pod_name;
        })
        if (selected_pod) {
            this.data.hubspot.company_default_email = selected_pod['pod_contact_email']; //refill these fields
            this.data.hubspot.contact_name = selected_pod['pod_contact_person'];
          return selected_pod.id
        }
        return null;
      },
      set(newValue) {
        this.data.hubspot.pod_id = newValue;
      }
    },
    hubspot_loan_purposes() {
        return this.options.hubspot_loan_purpose;
      },
  },
  async beforeCreate() {
    const params = {
      types: [
        'hubspot_branding_type',
        'hubspot_loan_purpose'
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  watch: {
    'data.hubspot.broker.name'(newVal) {
      if (!newVal) {
        this.data.hubspot.broker.user_id = null;
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "../assets/scss/md-custom/_ausloans-colors.scss";
.sub-header {
  background-color: $ausloans-blue-light !important;
  border-radius: 5px;
  margin-bottom: 15px;
  color: white;
}
.referrer-logo {
    width: 100px;
    margin-top: 15px;
}
</style>
